<template>
    <div>
        <p v-if="!(source.length<maxRes)" style="margin-left: 15px; margin-top: 40px;"> {{$Jed.firstUpperTranslate("This research is too generic, these are the first")+" "+ maxRes +" " + $Jed.translate("results found")}}</p> <!--ne mostro sempre al massimo maxRes, se sono di meno non mostro l'avviso-->
        <p v-if="modelNotFound" style="margin-left: 15px; margin-top: 40px;"> {{$Jed.firstUpperTranslate("Results not filtered because model not found")}}</p> <!--avviso che non ho potuto filtrare per modello perchè non esiste-->
        <div class="panel panel-default" style="margin: 0px 10px;">
            <div class="panel-heading headers" role="tab" style="padding: 10px 0px; display: table; width: 100%;">
                <span v-for="r_col in results_cols" 
                    style="display: table-cell; vertical-align: middle; padding: 0px 5px;" :style="{'width': r_col.width[type]}">
                    <span>{{ $Jed.firstUpperTranslate(r_col.text) }}</span>
                </span>
            </div>
        </div>
        <div v-if="source" :id='id' class="panel-group resultsTable" role="tablist" aria-multiselectable="true" style="margin-bottom: 0px;">

            <!-- risultati -->
            
            <div v-for="(res, index) in source" class="panel panel-default" style="margin: 0px 0px 1px 0px">
                
                <!-- <div class="panel-heading collapsed" role="tab" style="padding: 10px 0px;" @click="fetchFathers(res)" @click="fetchFathers(res, index)"-->
                <div class="panel-heading" :class="{'collapsed': activeSearch != index}" role="tab" style="padding: 10px 0px;" 
                data-toggle="collapse" :href=" '#collapse'+index " aria-expanded="true" :aria-controls="'collapse'+index" > <!--@click.stop.prevent="navigateToNode(res)"-->
                    <span v-for="r_col in results_cols"  :style="{'width': r_col.width[type], 'display': 'inline-block', 'padding': '0px 5px', 'vertical-align': 'middle'}"> 
                        <span v-if="r_col.datafield == 'typ'"><i :class="getIconClass(res)"></i></span> 
                        <span v-else-if="r_col.datafield == 'gra'" :class="{'pointer': r_col.ex != null}" @click.prevent="r_col.ex ? r_col.ex(res) : null"> 
                            <div v-if="res.doc && res.doc.length>0"  class="embed-responsive embed-responsive-4by3 bg-cover" :style="{'width': '100%', 'background-image': 'url('+ anteprima(res.doc, 'doc') + ')'}">
                            </div>
                            <div v-else class="embed-responsive embed-responsive-4by3 bg-cover" :style="{'width': '100%', 'background-image': 'url('+ anteprima(res.gra, 'gra') + ')'}">
                            </div>
                        </span>
                        <span v-else :class="{'pointer': r_col.ex != null}" @click.prevent="r_col.ex ? r_col.ex(res) : null">{{res[r_col.datafield]}}</span>
                    </span>
                </div>
                
                <div v-if="type=='criteria' && !$root.preferences.splitSearch" :id="'collapse' + index" class="panel-collapse collapse" role="tabpanel">
                    <div v-if="$root.preferences.splitSearch && res.fat == null" style="padding-bottom: 10px;">
                        <div class="sk-cube-grid" style="margin: 30px auto;">
                            <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
                            <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
                            <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
                            <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
                            <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
                            <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
                            <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
                            <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
                            <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
                        </div>
                    </div>

                    <div v-else-if="$Behaviors.search.fathersDescriptions" v-for="fath in res.fat" style="display: table; width: 100%;"
                        :class="{'active': (fath.id == $root.active_tree_item.id && ($route.query.p == fath.a_idp || $route.query.p == null ) )}">
                        <span v-for="(fd_col, i) in $Behaviors.search.fathersDescriptions" class="customCell" :class="{'pointer': i == fath.idpdes.length-1 ? true : null}"
                                @click.prevent="i == fath.idpdes.length-1 ? navigateToFather(fath) : null" :style="{'width': fd_col.width, 'text-decoration': i == fath.idpdes.length-1 ? 'underline' : '', 'text-decoration-color': i == fath.idpdes.length-1 ? '#3c8dbc' : '', 'color': i == fath.idpdes.length-1 ? '#3c8dbc' : ''}"> 
                            <div>{{fath.idpdes[i]}}</div>
                        </span>
                    </div>

                    <div v-else v-for="fath in res.fat" style="display: table; width: 100%;"
                    :class="{'active': (fath.id == $root.active_tree_item.id && ($route.query.p == fath.a_idp || $route.query.p == null ) )}">
                        <span v-for="f_col in fathers_cols" class="customCell" :class="{'pointer': f_col.ex != null}"
                        @click.prevent="f_col.ex ? f_col.ex(fath) : null"
                        :style="{'width': f_col.width}"> 
                            <span v-if="f_col.datafield == 'typ'"><i :class="getIconClass(fath)"></i></span>
                            <span v-else-if="f_col.datafield == 'des'">
                                <div>{{fath.des}}</div>
                                <div v-if="fath.idp" style="font-size: smaller">
                                    <i :class="$root.icons.tree_son"></i> 
                                    <span style="font-weight: 600;">{{fath.idp[0]}}</span>
                                    <span v-if="fath.idp.length > 1">{{' / ' + fath.idp.slice(1, fath.idp.length).join(' / ')}}</span>
                                </div>
                            </span>
                            <span v-else>{{fath[f_col.datafield]}}</span>
                        </span>
                    </div>
                </div>

            </div>
            <div style="position: absolute; top: 150px; left: 300px;" v-if="isLoading" class="sk-cube-grid">
                <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
            </div>
        </div>
    </div>
</template>
<script>

import search_mixin from '../../mixins/search_mixin.js';
import { eventBus } from "../../eventbus.js";
    
    export default {
        props: {
            source: null,
            maxRes: {
                type: Number,
                default: 0
            },
            modelNotFound: Boolean,
            type: String,
            id: String
        },
        mounted: function(){
            console.log('SearchResults mounted with source: ', this.source)
            console.log(this.type)
            if(this.type == 'criteria'){
                this.results_cols = this.criteria_results_cols
            }else{
                this.results_cols = this.filter_results_cols
            }
        },
        created: function(){
            console.log('SearchResults created')
            console.log(this.type)
            var vm = this;
            eventBus.$on('document_loaded', function(){
                vm.isLoading = false;
            })
        },
        mixins: [search_mixin],
        data: function(){
            var vm = this;
            return {
                filter_results_cols: [
                    {
                        datafield: "gra",
                        width:{"filter":"30%"},
                        text: "graphic",
                        type: "filter",
                        ex: vm.navigateToNode
                    }, {
                        datafield: "cod",
                        width:{"criteria":"20%","filter": "35%"}, 
                        text: "code",
                        type: "filter",
                        ex: vm.navigateToNode
                    }, {
                        datafield: "des",
                        width:{"criteria":"43%","filter": "35%"}, 
                        text: "description",
                        type: "filter",
                        ex: vm.navigateToNode
                    }
                ],
                criteria_results_cols: [
                    {
                        datafield: "typ",
                        width:{"criteria":"7%"},
                        text: "type",
                        type: "criteria"
                    }, {
                        datafield: "cod",
                        width:{"criteria":"20%","filter": "35%"}, 
                        text: "code",
                        type: "criteria",
                        ex: vm.fetchFathers
                    }, {
                        datafield: "spi",
                        width:{"criteria":"20%",}, 
                        text: "substitute code",
                        type: "criteria",
                        ex: vm.fetchFathers
                    }, {
                        datafield: "des",
                        width:{"criteria":"43%","filter": "35%"}, 
                        text: "description",
                        type: "criteria",
                        ex: vm.fetchFathers
                    }, {
                        datafield: "occ",
                        width:{"criteria":"10%"}, 
                        text: "occurrence",
                        type: "criteria",
                        ex: vm.fetchFathers
                    }
                ],
                fathers_cols: [
                    {
                        datafield: "typ",
                        width: "7%",
                        text: "type"
                    }, {
                        datafield: "id",
                        width: "25%",
                        text: "code"
                    }, {
                        datafield: "des",
                        width: "68%",
                        text: "description",
                        ex: vm.navigateToFather
                    }
                ],
                results_cols: [],
                documents: [],
                isLoading: false,
                activeSearch: -1
            }
        },
        methods: {
            fetchFathers(res, index){
               this.activeSearch = index;
                console.log('Mostra albero impieghi: ', this.$Behaviors.search.showUsesTreePanel);
                if(this.$Behaviors.search.showUsesTreePanel){
                    eventBus.$emit("searchUsesTree", res)
                }         
            },
            getIconClass(res) {
                if(res.typ && this.$root.prod_icons[res.typ]){
                    return this.$root.prod_icons[res.typ].icn; 
                }else{
                    return ""
                }
            },
            navigateToFather: function(father){
                var focus = this.$Behaviors.focusBy() == 'pos' ? 'pos' : 'id';

                this.$root.navigateTo(father.id, null, father[focus], father.a_idp);
            },
            navigateToNode: function(node){
                console.log(node)
                if(node.typ == 'Modello' || node.typ == 'Modello Abbigliamento'){
                    var father = node.fat[0].id ? node.fat[0].id : node.fat[0].fid
                    this.$root.navigateTo(node.cod, father, node.fat[0].pos, null);
                }else if(node.typ == 'Articoli di stampa'){ 
                    this.isLoading = true;

                    this.queryThis(node.cod, node.fat[0].id);

                    var vm = this;
                    eventBus.$emit("closeSidebarDocumenti")
                    eventBus.$emit("loadingDocument")
                    setTimeout(function(){
                        //caricamento diretto del documento nel viewer 
                        try{
                            var d = node.doc[0];
                            var fname =  d.na.split(".");
                            d.ext = fname.pop();
                            d.filename = fname.join(".");
                            if(d.np){
                                d.preview = vm.getPage(d.filename, 1, d.np) + "_tn.jpg";
                            }
                            eventBus.$emit("changeView", "ImgLayout")
                            vm.$nextTick(function(){
                                vm.$nextTick(function(){
                                    vm.reading = d;
                                    eventBus.$emit("read_pdf", {d:d, from: 'rec-list-doc'})
                                })
                            })
                        }catch(e){
                            console.log(e)
                            eventBus.$emit("alert", {type: "warning", message: vm.$Jed.firstUpperTranslate("missing document")});
                            vm.isLoading = false;
                        }
                    }, 100); 
                }
            },
            anteprima(gra, type){
                if(gra && gra.length > 0){
                    if(type=='gra'){
                        return this.$root.getGraphic(gra[0].sfn, "thumb" , true)
                    }else if(type=='doc'){
                        return this.$root.msPath + '/'+ this.$Configs.licenseId +'/doc/pag/' + gra[0].na.split('.')[0] + '/' + this.getPage(gra[0].na.split('.')[0], 1, gra[0].np) + '_tn.jpg'
                    }
                } else {
                    return ""
                }
            },
            getFigure4: function(n){
                n = n.toString();
                var figures = n.length;
                var res = "";
                for(var i = 0; i < 4-figures; i++){
                    res += "0"
                }
                res += n;
                return res;
            },
            getPage: function(name, npage, ntot){
                return name + "_p" + this.getFigure4(npage) + "-" + this.getFigure4(ntot);
            },
            queryThis: function(id, fid, path, step, focus, nav_promise) {
                var vm = this;
                this.$root
                .microservice({
                role: "catalog",
                cmd: "SearchByFather",
                params: {
                    fid: id,
                    // aggiunto gfid nelle searchByFather che richiedono info sul padre (meta: true), così posso identificare univocamente il nodo, e non cercare per "sid": fid ottenendo un primo res casuale
                    gfid: fid,
                    labels: "all",
                    leaves: true,
                    prod_info: ["att", "not", "gra", "typ", "spi", "doc", "mqt","iti"],
                    meta: true,
                    meta_prod_info: ["gra", "typ", "def","iti"],
                    saleability: true
                }
                })
                .then(
                response => {
                    var res = response.body;
                    try {
                    res = JSON.parse(response.body);
                    } catch (err) {}

                    this.children = [];
                    if (res.children) {
                    for (var i = 0; i < res.children.length; i++) {
                        var obj = res.children[i];
                        if(!obj.lin){
                            obj.opened = false;
                            obj.triggered = false;
                            obj.execonopen = null;
                            obj.nav_promise = null;

                            this.children.push(obj);
                        }
                    }
                    
                    if (path != null && step != null) {
                        var extract;
                        try {
                        extract = path[step + 1].id;
                        } catch (err) {
                        console.log(err)
                        }
                        if (extract == null || extract == "") {
                        this.changeRoute(res, focus, {"path": path, "step": step, "nav_promise": nav_promise});
                        //quando sto eseguendo una navigazione diretta, commit active item solo all'ultimo step della procedura
                        
                        } else {
                        this.$nextTick(function() {
                            this.direct(path, step, focus, nav_promise);
                        });
                        this.loading = false;
                        }
                        
                    } else {
                        this.changeRoute(res); 
                    }
                    } else {
                    this.loading = false;
                    }

                    if (this.children.length == 0) {
                    this.am_i_leaf = true;
                    }

                    this.leaves = []
                    if(res.leaves){
                    for (var i = 0; i < res.leaves.length; i++) {
                        var obj = res.leaves[i];
                        if(obj.typ == 'Articoli di stampa'){
                        this.leaves.push(obj);
                        }
                    }
                    }
                },
                err => {
                    this.loading = false;
                    console.log('SearchResults - queryThis')
                    console.log(err)
                    //vedi gestione errore in main.js > microservice
                }
                )
                .catch(err => {
                    console.log(err);
                    var msg = err && err.body && err.body.error ? err.body.error : ''
                    eventBus.$emit('alert', {
                    message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
                    type: "error",
                    action: ''
                    })
                });
            },
            changeRoute: function(res, focus, nextParams) {
                var vm = this;
                this.$store.commit("setActive", {
                    father: res.answer,
                    children: res.children,
                    leaves: res.leaves
                });
            }
        }
    }
</script>
<style scoped>
.customCell {
    display: table-cell; 
    padding: 2px 5px; 
    height: 48px; 
    vertical-align: middle;
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
}
.panel {
    border-radius: 2px;
    border-width: 0px;
}

.panel-heading.headers {
    color: rgba(0, 0, 0, 0.54);
    background-color: #f5f7f7;
    border-bottom: 1px solid #bdc3c7;
}

.pointer {
    cursor: pointer;
}

.resultsTable {
    margin-right: 10px;
    margin-left: 10px;
    overflow-y: auto;
}

.embed-responsive.bg-cover {
    background-position: left 100% 100%;
    -webkit-background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    -o-background-size: 100% 100%;
    background-size: 100% 100%;
    
    background-position: center;
    background-size: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/menu-components/SearchResults.vue?f4115c78